"use client";

import _slicedToArray from "/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCommand } from "./KUU7WJ55.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { useMergeRefs, useTagName } from "./ABQUS43J.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/button/button.tsx
import { isButton } from "@ariakit/core/utils/dom";
import { useEffect, useRef, useState } from "react";
var TagName = "button";
var useButton = createHook(function useButton2(props) {
  var ref = useRef(null);
  var tagName = useTagName(ref, TagName);
  var _useState = useState(function () {
      return !!tagName && isButton({
        tagName: tagName,
        type: props.type
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isNativeButton = _useState2[0],
    setIsNativeButton = _useState2[1];
  useEffect(function () {
    if (!ref.current) return;
    setIsNativeButton(isButton(ref.current));
  }, []);
  props = __spreadProps(__spreadValues({
    role: !isNativeButton && tagName !== "a" ? "button" : void 0
  }, props), {
    ref: useMergeRefs(ref, props.ref)
  });
  props = useCommand(props);
  return props;
});
var Button = forwardRef(function Button2(props) {
  var htmlProps = useButton(props);
  return createElement(TagName, htmlProps);
});
export { useButton, Button };